"use strict";
function w(t, n) {
  t = t || 10;
  const c = new Array(t), f = new Array(t);
  let e = 0, o = 0, r;
  return n = n !== void 0 ? n : 1e3, function(l) {
    const u = Date.now(), i = f[o];
    r || (r = u), c[e] = l, f[e] = u;
    let a = o, d = 0;
    for (; a !== e; )
      d += c[a++], a = a % t;
    if (e = (e + 1) % t, e === o && (o = (o + 1) % t), u - r < n)
      return;
    const s = i && u - i;
    return s ? Math.round(d * 1e3 / s) : void 0;
  };
}
export {
  w as default
};
//# sourceMappingURL=index.es417.js.map
